import logoOrb from "../logo-orb.png";
import americanDesign from "../american-design.png";
import customLogo from "../custom.png";
import trademarkLogo from "../uspto.png";
export const COMPANIES = [
  {
    id: "logo-orb",
    name: "Logo Orb",
    email: "info@logoorb.com",
    phone: "+ 1 (510) 476-9126",
    address: "Cimarron Holding Inc. 200 Park Ave Suite 1700 New York, NY 10166",
    logo: logoOrb,
  },
  {
    id: "american-design",
    name: "American Design Studios",
    email: "info@americandesignstudios.com",
    phone: "+ 1 (510) 476-9126",
    address: "447 Sutter St Ste 405 San Francisco, CA 94108",
    logo: americanDesign,
  },
  {
    id: "custom-logo",
    name: "The Custom Logos",
    email: "info@thecustomlogos.com",
    phone: "+1 (510) 476 9126",
    address: "447 Sutter St Ste 405 San Francisco, CA 94108",
    logo: customLogo,
  },
  {
    id: "trademark-invoice",
    name: "Trademark Invoice",
    email: "",
    phone: "USPTO Madison Building",
    address: "600 Dulany Street Alexandria, VA 22314",
    logo: trademarkLogo,
  },
];

export const DEFAULT_INVOICE_DETAILS = {
  invoiceDate: new Date().toLocaleDateString(),
  dueDate: new Date().toLocaleDateString(),
  description: "Logo Plus",
  amount: 99,
};
